var base = require("./base");
var regex = require("../utilities/regex");
var debounce = require("lodash/debounce");
import "jquery-zoom";
import { pdpImages } from "../utilities/carouselSlickConfig";
import { initMTabsPDP, initRecommendationsCarousel } from "./detailsUtil";
import { intersectionObserver } from "./detailsObserverEvents";
import { initLazyLoad as initLazyLoadTemplate } from "../components/lazyLoadTemplate";
import { initBrandsRecommendationsCarousels } from "../recommendations/recommendationsUtil";

function reloadZoom() {
    var $cache = {
        carouselItem : $(".pdp-carousel-item"),
        zoomImage : $(".ct-zoom-image"),
        pdpImage : $(".ct-product-image:not(.ct-product-image--quickview)")
    };

    if (window.mqRespond.status.desktop || window.mqRespond.status.desktopLarge) {
        $cache.carouselItem.removeAttr("data-toggle");
        $cache.carouselItem.removeAttr("data-target");
        $cache.zoomImage.closest(".modal-body").trigger("zoom.destroy");
        $cache.pdpImage.closest(".pdp-carousel-item").zoom({
            magnify: 0.7,
            on: "click",
            onZoomIn: () => {
                $cache.carouselItem.addClass("zoomed-in").closest(".pdp-images-carousel.slick-initialized").find(".slick-dots").hide();
            },
            onZoomOut: () => {
                $cache.carouselItem.removeClass("zoomed-in").closest(".pdp-images-carousel.slick-initialized").find(".slick-dots").show();
            },
            callback: () => {
                $cache.pdpImage.parent().off("mouseleave").on("mouseleave", function () {
                    const $this = $(this);
                    if ($this.hasClass("zoomed-in")) { $this.find(".ct-product-image").click(); }
                });
            }
        });
    } else {
        $cache.carouselItem.attr("data-toggle", "modal");
        $cache.carouselItem.attr("data-target", "#pdpZoom");
        $cache.pdpImage.closest(".pdp-carousel-item").trigger("zoom.destroy");
        $cache.carouselItem.off("click.zoom touchstart.zoom touchend.zoom touchmove.zoom");
        initPDPZoomModal();
    }
}

function initPDPZoomModal() {
    const $cache = {
        zoomImage : $(".ct-zoom-image"),
        zoomModal: $("#pdpZoom"),
        closeZoomModalBtn: $(".ct-zoom-close")
    };

    $("body").on("shown.bs.modal", "#pdpZoom", event => {
        const baseImg = $(event.relatedTarget).find(".ct-product-image");

        if (baseImg) {
            const baseSrc = baseImg.attr("src");
            const baseAlt = baseImg.attr("alt");
            const baseTitle = baseImg.attr("title");

            $cache.zoomImage.attr("src", baseSrc);
            $cache.zoomImage.attr("alt", baseAlt);
            $cache.zoomImage.attr("title", baseTitle);

            $cache.zoomImage.closest(".modal-body").zoom({
                magnify: 0.7,
                on: "click",
                onZoomIn: () => {
                    $cache.zoomImage.closest(".modal-body").off("touchstart.zoom touchend.zoom");
                    $cache.zoomImage.addClass("zoomed-in");
                },
                onZoomOut: () => {
                    $cache.zoomImage.removeClass("zoomed-in");
                    $cache.zoomModal.modal("hide");
                },
                callback: () => {
                    let zoomClickEvent = $.Event("click");
                    zoomClickEvent.pageX = document.documentElement.clientWidth / 2;
                    zoomClickEvent.pageY = document.documentElement.clientHeight / 2;
                    $cache.zoomImage.closest(".modal-body").trigger(zoomClickEvent);
                }
            });

            $cache.closeZoomModalBtn.removeAttr("data-dismiss");
        }
    });

    $cache.closeZoomModalBtn.off("click").on("click", e => {
        e.preventDefault();

        if ($cache.zoomImage.hasClass("zoomed-in")) {
            $cache.zoomImage.closest(".modal-body").trigger("click");
        } else {
            $cache.zoomModal.modal("hide");
        }
    });

    // Clean images when modal closes
    $("body").on("hidden.bs.modal", "#pdpZoom", function () {
        $cache.zoomImage.attr("src", "");
        $cache.zoomImage.attr("data-src", "");
        $cache.zoomImage.attr("alt", "");
        $cache.zoomImage.attr("title", "");
    });
}

/**
* Expand/collapse Note section on page load
*/
const noteSectionVisibility = (resize = false) => {
    const isMobile = window.mqRespond.status.mobile;
    const tileQty = document.querySelector(".ct-tile-quantity");
    const addNoteSection = document.querySelector(".add-note-section");
    const expandNoteSection = document.querySelector(".expand-note-section");

    if (!tileQty || !addNoteSection) { return; }

    if (!tileQty.classList.contains("d-none")) {
        if (isMobile && !resize && addNoteSection.classList.contains("d-none")) {
            expandNoteSection.click();
        }
    }
};

module.exports = {
    availability: base.availability,
    addToCart: base.addToCart,
    updateOutOfStock: function () {
        //Updates the states for the product availability options
        base.updateProductAvailabilityOptions();
    },

    lazyLoadPDPContent: function () {
        var $recipeImageContent = $(".recipe-image-content");
        if ($recipeImageContent.length && $recipeImageContent.attr("data-url")) {
            $recipeImageContent.load($recipeImageContent.attr("data-url"), function () {
                document.dispatchEvent(new Event("dataLayer.contentLoaded"));
            });
        }
    },

    updateAttributesAndDetails: function () {
        $("body").on("product:statusUpdate", function (e, data) {
            var $productContainer = $(".product-detail[data-pid=\"" + data.id + "\"]");

            $productContainer.find(".description-and-detail .product-attributes")
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find(".description-and-detail .description")
                    .removeClass("hidden-xl-down");
                $productContainer.find(".description-and-detail .description .content")
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find(".description-and-detail .description")
                    .addClass("hidden-xl-down");
            }

            if (data.longDescription) {
                $productContainer.find(".description-and-detail .details")
                    .removeClass("hidden-xl-down");
                $productContainer.find(".description-and-detail .details .content")
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find(".description-and-detail .details")
                    .addClass("hidden-xl-down");
            }
        });
    },

    initMobileBackButton: function () {
        const searchMobileBackBtn = document.querySelector(".js-toggle-pdp-back");
        if (searchMobileBackBtn) {
            searchMobileBackBtn.addEventListener("click", () => {
                let backPageURL = searchMobileBackBtn.dataset.href;
                if (backPageURL == null) {
                    window.location.href = searchMobileBackBtn.dataset.home;
                } else {
                    window.location.href = backPageURL;
                }
            });
        }
    },

    initPdpImagesCarousel: function () {
        const $productImagesCarousel = $(".pdp-images-carousel");

        $productImagesCarousel.each(function (i, e) {
            var $element = $(e);
            if (!$element.hasClass("slick-initialized")) {
                $element.slick(pdpImages);
            }
        });
    },

    initZoom: function () {
        var $cache = {
            carouselItem: $(".pdp-carousel-item")
        };

        if (window.mqRespond.status.desktop || window.mqRespond.status.desktopLarge) {
            $cache.carouselItem.removeAttr("data-toggle");
            $cache.carouselItem.removeAttr("data-target");
            $(".ct-product-image").parent().zoom({
                magnify: 0.7,
                on: "click",
                onZoomIn: () => {
                    $cache.carouselItem.addClass("zoomed-in").closest(".pdp-images-carousel.slick-initialized").find(".slick-dots").hide();
                },
                onZoomOut: () => {
                    $cache.carouselItem.removeClass("zoomed-in").closest(".pdp-images-carousel.slick-initialized").find(".slick-dots").show();
                },
                callback: () => {
                    $(".ct-product-image").parent().off("mouseleave").on("mouseleave", function () {
                        const $this = $(this);
                        if ($this.hasClass("zoomed-in")) { $this.find(".ct-product-image").click(); }
                    });
                }
            });
        } else {
            $cache.carouselItem.attr("data-toggle", "modal");
            $cache.carouselItem.attr("data-target", "#pdpZoom");
            initPDPZoomModal();
        }
    },

    initResize: function () {
        $(window).on("resize", debounce(function () {
            reloadZoom();
            noteSectionVisibility(true);
        }, 200));
    },

    showSpinner: function () {
        $("body").on("product:beforeAddToCart product:beforeAttributeSelect", function () {
            $.spinner().start();
        });
    },

    updateAttribute: function () {
        $("body").on("product:afterAttributeSelect", function (e, response) {
            reloadZoom();
            if ($(".product-detail>.bundle-items").length || $(".product-set-detail").eq(0)) {
                response.container.data("pid", response.data.product.id);
                response.container.find(".product-id").text(response.data.product.id);
            } else {
                $(".product-id").text(response.data.product.id);
                $(".product-detail:not(\".bundle-item\")").data("pid", response.data.product.id);
            }
        });
    },

    updateAddToCart: function () {
        $("body").on("product:updateAddToCart", function () {
            var enable = $(".product-availability").toArray().every(function (item) {
                return $(item).data("available") && $(item).data("ready-to-order");
            });
            $("button.add-to-cart-global").attr("disabled", !enable);
        });
    },

    updateAvailability: function () {
        $("body").on("product:updateAvailability", function (e, response) {
            $("div.availability", response.$productContainer)
                .data("ready-to-order", response.product.readyToOrder)
                .data("available", response.product.available);

            $(".availability-msg", response.$productContainer)
                .empty().html(response.message);

            if ($(".global-availability").length) {
                var allAvailable = $(".product-availability").toArray()
                    .every(function (item) { return $(item).data("available"); });

                var allReady = $(".product-availability").toArray()
                    .every(function (item) { return $(item).data("ready-to-order"); });

                $(".global-availability")
                    .data("ready-to-order", allReady)
                    .data("available", allAvailable);

                $(".global-availability .availability-msg").empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },

    /**
     * Save the note added by a customer for a product added to the basket
     */
    saveProductNote: function () {
        /**
         * Hide/Show the Add note container
         * @param {Object} element
         */
        function hideShowAddNoteContainer(element) {
            if (element == undefined || element == null || element == "") {
                return;
            }

            var $notesWrapper = $(element).closest(".js-notes-container"),
                $container = $notesWrapper.find(".add-note-section").last(),
                $noteInput = $container.find(".add-product-note"),
                $pdpPage = $(".ct-pdp"),
                savedNote = $noteInput[0].dataset.savedNote;

            if ($container.hasClass("d-none")) {
                $container.removeClass("d-none");
                $pdpPage.addClass("is-note-shown");
            } else {
                $container.addClass("d-none");
                $pdpPage.removeClass("is-note-shown");
            }

            var productNoteModal = document.getElementById("product-note-modal");
            if (productNoteModal) {
                var productId = productNoteModal.dataset.productId;
                var cartTile = document.querySelector(`.ct-cart-tile[data-pid='${productId}']`);
                var notePreviewSection = document.querySelector(`.note-preview-section[data-pid='${productId}']`);
                var cartBtnsDetails = document.querySelector(`.js-cart-add-note-btn[data-pid='${productId}']`);
                var previousSavedNotes = notePreviewSection.querySelector(".note-preview-display");
                if (previousSavedNotes) {
                    previousSavedNotes.dataset.savedNote = savedNote;
                    previousSavedNotes.innerHTML = savedNote;
                    if (savedNote.trim() !== "") {
                        cartTile.classList.add("ct-cart-tile-has-note-js");
                        notePreviewSection.classList.remove("d-none");
                        cartBtnsDetails.classList.add("notes-enabled-js");
                        cartBtnsDetails.classList.remove("notes-disabled-js");
                    } else {
                        cartTile.classList.remove("ct-cart-tile-has-note-js");
                        notePreviewSection.classList.add("d-none");
                        cartBtnsDetails.classList.remove("notes-enabled-js");
                        cartBtnsDetails.classList.add("notes-disabled-js");
                    }
                }
            } else {
                const expandNoteSection = document.querySelector(".expand-note-section");
                if (savedNote.trim() !== "") {
                    expandNoteSection.classList.add("notes-enabled-js");
                    expandNoteSection.classList.remove("notes-disabled-js");
                } else {
                    expandNoteSection.classList.add("notes-disabled-js");
                    expandNoteSection.classList.remove("notes-enabled-js");
                }
            }

            $(productNoteModal).modal("hide");
        }

        /**
         * Event to display the input for product note
         */
        $(document).off("click", ".add-note button").on("click", ".add-note button", function (e) {
            hideShowAddNoteContainer(e.currentTarget);
        });

        document.querySelectorAll(".js-note-reset-button").forEach(element => {
            element.addEventListener("click", e => {
                const $this = e.currentTarget;
                const $notesContainer = $this.parentElement;
                const $noteInput = $notesContainer.querySelector(".add-product-note");
                const productID = $noteInput.dataset.pid;
                const $cartBottomDetails = document.querySelector(`.ct-cart-tile-bottom-details[data-pid="${productID}"]`);
                const savedNote = $noteInput.dataset.savedNote;

                if (savedNote == "") {
                    $noteInput.value = "";
                    $noteInput.classList.remove("filled");
                    $notesContainer.querySelector(".js-note-reset-button").classList.remove("d-block");
                } else {
                    if (savedNote === $noteInput.value) {
                        hideShowAddNoteContainer($this);

                        if ($cartBottomDetails) $cartBottomDetails.classList.remove("d-none");
                    } else {
                        $noteInput.value = savedNote;
                        $noteInput.classList.add("filled");
                        hideShowAddNoteContainer($this);

                        if ($cartBottomDetails) $cartBottomDetails.classList.remove("d-none");
                    }
                }
            });
        });

        /**
         * Event to save the note added by a customer at productLineItem level
         */
        $(document).off("submit", "form.add-note-form").on("submit", "form.add-note-form", function (e) {
            e.preventDefault();

            var $form = $(this);
            var url = $form.attr("action");
            var $noteInput = $form.find(".add-product-note");
            var note = $noteInput.val().replace(regex.values.nonASCIIWithPTChars, "").trim();
            var button = $(this).find(".js-add-note-button");

            if (note == "" && $noteInput.hasClass("filled")) {
                $noteInput.removeClass("filled");
            }

            if (note != undefined && note != null) {
                $form.find(".add-product-note").val(note);
                $.ajax({
                    url: url,
                    type: "post",
                    data: $form.serialize(),
                    success: data => {
                        $noteInput[0].dataset.savedNote = note;
                        document.dispatchEvent(new CustomEvent("dataLayer.notes", {
                            detail: {
                                "product": data.productID,
                                "status" : data.status
                            }
                        }));
                        hideShowAddNoteContainer(button);
                    },
                    error:  () => {
                        hideShowAddNoteContainer(button);
                    }
                });
            }
        });

        $(document).off("reset", "form.add-note-form").on("reset", "form.add-note-form", debounce(function () {
            var $form = $(this),
                note = $form.find(".add-product-note").val(),
                $availableNote = $(this).find(".available-note");

            if (note == "") {
                $availableNote.addClass("d-none");
                $form.find(".add-product-note").removeClass("filled");
            }
        }, 100));
    },

    // Initialize details tabs
    initTabs: initMTabsPDP,

    initRecommendationsCarousels: function () {
        initRecommendationsCarousel();

        //GTM custom event - start
        document.dispatchEvent(new Event("dataLayer.pdpRecommendation"));
        //GTM custom event - end
    },

    initPDPClass: function () {
        var $page = $(".page"),
            isPDP = $page.data("querystring").split("=")[0] == "pid";

        if (isPDP) {
            $page.addClass("ct-pdp");
        }
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    noteSectionVisibility: noteSectionVisibility,
    intersectionObserver: intersectionObserver,
    initLazyLoadTemplate: initLazyLoadTemplate,
    initBrandsRecommendationsCarousels: initBrandsRecommendationsCarousels
};
